export const headerImages = [
	{
		big: 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/2560-1280/GettyImages-615355778.jpg',
		small:
			'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/960-375/GettyImages-615355778.jpg',
	},
	{
		big: 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/2560-1280/GettyImages-1080096794.jpg',
		small:
			'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/960-375/GettyImages-1080096794.jpg',
	},
	{
		big: 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/2560-1280/GettyImages-1330597560.jpg',
		small:
			'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/960-375/GettyImages-1330597560.jpg',
	},
	{
		big: 'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/2560-1280/GettyImages-1394747786.jpg',
		small:
			'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/960-375/GettyImages-1394747786.jpg',
	},
];


export const animatedTitle =
	'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/MI-ZONA-VIP(Mobile).svg';

export const titleImage =
	'https://vgedonehubappsstaweupro.blob.core.windows.net/storage/images-portal/modulo-header/MI-ZONA-VIP(Desktop).svg';
